<template>
    <div class="container-pieChart_v_d">
        <v-chart :options="option"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/pie'



import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'


export default {
  name: 'pieChart_v_d',
  props: {  
    title:{
      type: String,
      default: ""
    },
    num:{
       type: Number,
       default: 100
    }
  },
  data () {  
    return {     
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
    this.option = {
       legend: {
      
          x: 'center',
          y: 'bottom',
          itemWidth: 6,
          itemHeight: 6,
          icon: 'rect',
          align:"left",
          textStyle: {
              color: "#fff", // 图例文字颜色
              fontSize:12
          },
           padding: 20,  
          itemGap: 0,
          data: ["广州区", '广州K11']
        },
        grid: {
            top:'0',          
            bottom: '0',
            containLabel: true
        },
       title: {
         
              zlevel: 0,
              text: "8万",
              // for
              textStyle:{
                color:'#fff',
                fontSize:16
              },
                itemGap:1,
                subtext:'广州区',  
                 subtextStyle:{
                color:'#fff',
                fontSize:12
              }, 
              x: 'center',//文字位置
              y:'center'//文字位置
          },
        series: [
            {
                
                type: 'pie',
                radius: ['48%', '60%'], 
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
              
                labelLine: {
                    show: false
                },
                data: [
                    {value: this.num, name: '数值',itemStyle:{color:'#16CEB9'},
                    name: '广州区',
                    },
                    {value: 100-this.num, name: '剩余',itemStyle:{color:'#000000'}},
              
                ]
            },
            {
            
                type: 'pie',
                radius: ['33%', '45%'], 
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
              
                labelLine: {
                    show: false
                },
                data: [
                    {value: this.num, name: '数值',itemStyle:{color:'#377dff'}, name: '广州K11'},
                    {value: 100-this.num, name: '剩余',itemStyle:{color:'#000000'}},
              
                ]
            }
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-pieChart_v_d{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>